
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account/[[...params]]",
      function () {
        return require("private-next-pages/account/[[...params]].page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/account/[[...params]]"])
      });
    }
  